export const ROLE_MARKS = {
    dev_admin: { id: "dev", label: "Dev", symbol: "Ⓓ", color: "#531b90" },
    space: { id: "system", label: "System", symbol: "Ⓢ", color: "#941100" },
    agency: { id: "agency", label: "Agency", symbol: "Ⓐ", color: "#009193" },
    company: { id: "company", label: "Company", symbol: "Ⓒ", color: "#929000" },
    store: { id: "store", label: "Store", symbol: "Ⓣ", color: "#008F00" },
};
/** Accepts account role groups and legacy UI aliases, case-insensitively. */
export function getRoleMark(role) {
    let group = role.toLowerCase();
    if (group === "dev")
        group = "dev_admin";
    if (group === "system")
        group = "space";
    if (!Object.prototype.hasOwnProperty.call(ROLE_MARKS, group))
        return undefined;
    return ROLE_MARKS[group];
}
/** Role marks are visible to agency users and administrators. */
export function canShowRoleMark(group) {
    return group === "agency" || group === "space" || group === "dev_admin";
}
